module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"boolean.TRUE":"Oui","boolean.FALSE":"Non","required":"Requis"}}')
  delete Component.options._Ctor
}
